import styled from "styled-components";

export const CourseDetails = styled.div`
  text-align: left;
  color: #707070;
  span.detail {
    display: block;
  }
  @media (min-width: 420px) {
    span.detail {
      display: inline;
    }
    span.detail:after {
      content: "|";
      color: #707070;
      padding: 10px;
    }
  }
`;

export const FollowingCourse = styled.button`
  all: unset;
  cursor: pointer;
  color: #1070b6;
  text-decoration: underline;
`;
